import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { ALL_OPTION } from '@/common/constants';
import { OptionKey } from '@/common/types';
import { API_URL } from '@/dtos';

import { SearchParams } from '../../EligibleServices.types';
import { CategoryDto } from '../../EligibleServices.types.ts';
import { useFormatEligibleServicesData } from '../hooks';

const hasFilterParams = (params?: OptionKey[]) =>
  params?.length && params?.length > 0 && !params?.some((param: OptionKey) => param === ALL_OPTION.key);

const useGetEligibleServicesListQuery = (params?: SearchParams, parentId?: number) => {
  const { data, isLoading, isSuccess } = useQuery(
    [API_URL.CATEGORIES_SERVICES, params, parentId],
    () =>
      api.get<CategoryDto[]>(API_URL.CATEGORIES_SERVICES, {
        params: _.pickBy({
          name: params?.name,
          sort: params?.sort,
          categories: hasFilterParams(params?.categories) ? params?.categories?.join(', ') : '',
          service_types: hasFilterParams(params?.types) ? params?.types?.join(', ') : '',
        }),
      }),
    {
      enabled: !parentId,
    }
  );

  const formattedEligibleServices = useFormatEligibleServicesData(data?.data);

  return {
    formattedData: formattedEligibleServices?.formatData,
    total: formattedEligibleServices?.total,
    isLoading,
    isSuccess,
  };
};

export default useGetEligibleServicesListQuery;
